export const RESTRICTED = 'RESTRICTED';
export const PUBLIC = 'PUBLIC';
export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';

export const ACCESS_OPTIONS = [
    // {
    //     label: 'Public Access',
    //     value: 'PUBLIC',
    // },
    {
        label: 'Restricted Access',
        value: 'RESTRICTED',
    },
];

export const CHANNEL_OPTIONS = [
    {
        label: 'Email',
        value: 'EMAIL',
    },
    {
        label: 'Phone',
        value: 'PHONE',
    },
];

export const EXPIRATION_OPTIONS = [
    {
        text: "15 Mins",
        key: 0,
        value: "15m"
    },
    {
        text: "30 Mins",
        key: 0,
        value: "30m"
    },
    {
        text: "1 hour",
        key: 0,
        value: "60m"
    },
    {
        text: "1 Day",
        key: 0,
        value: "1d"
    },
    // {
    //     text: "7 Days",
    //     key: 0,
    //     value: "7 Days"
    // },
    // {
    //     text: "30 Days",
    //     key: 1,
    //     value: "30 Days"
    // },
    // {
    //     text: "60 Days",
    //     key: 2,
    //     value: "60 Days"
    // },
    // {
    //     text: "90 Days",
    //     key: 3,
    //     value: "90 Days"
    // },
    // {
    //     text: "No Expiration",
    //     key: 4,
    //     value: "No Expiration"
    // }
]